// Copyright (c) 2017 Deere & Company

import actions from '../../actions-list';

export const updateSpaClaimsListFilterBy = filterBy => ({
    payload: filterBy,
    property: 'filterBy',
    type: actions.UPDATE_TCSM_SPA_CLAIMS_FILTER_BY
});

export const updateSpaClaimsListSortBy = sortBy => ({
    payload: sortBy,
    property: 'sortBy',
    type: actions.UPDATE_TCSM_SPA_CLAIMS_SORT_BY
});

export const updateSpaClaimsListSortDirection = sortDirection => ({
    payload: sortDirection,
    property: 'sortDirection',
    type: actions.UPDATE_TCSM_SPA_CLAIMS_SORT_DIRECTION
});



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/spa-claims-search-filters.js